var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainings2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1516 4.31962C11.9485 4.2254 11.7139 4.22688 11.5119 4.32367L1.67584 9.03796C1.41797 9.16155 1.25282 9.42103 1.25004 9.70697C1.24725 9.99292 1.40731 10.2556 1.66272 10.3842L4.85656 11.9922V16.9048C4.85656 16.9818 4.86844 17.0584 4.89178 17.1319C5.33847 18.5376 7.38338 20.75 11.8361 20.75C16.2864 20.75 18.5119 18.5477 19.084 17.1974C19.1232 17.1048 19.1434 17.0053 19.1434 16.9048V11.9404L20.25 11.4013V16C20.25 16.4142 20.5858 16.75 21 16.75C21.4142 16.75 21.75 16.4142 21.75 16V10.6704L22.3285 10.3885C22.5887 10.2617 22.7527 9.99655 22.75 9.70712C22.7472 9.4177 22.5781 9.15569 22.3156 9.03391L12.1516 4.31962ZM6.35656 16.7734V12.7475L11.4988 15.3365C11.7079 15.4418 11.9541 15.4434 12.1646 15.3409L17.6434 12.6713V16.7355C17.222 17.5243 15.5699 19.25 11.8361 19.25C8.07201 19.25 6.65797 17.5033 6.35656 16.7734ZM3.70068 9.73087L11.8413 5.82918L20.2535 9.73097L11.8415 13.8297L3.70068 9.73087Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainings2);
export default __webpack_public_path__ + "static/media/Trainings2.dffb926f1731ca9a3b8252e1bf467e23.svg";
export { ForwardRef as ReactComponent };